@for (bulkDiscount of licenseBulkDiscounts; track bulkDiscount) {
  <div>
    @if (bulkDiscount.buyedLicenseId === trackLicense.id) {
      <div class="license-bulk-discount" [ngClass]="{ 'license-bulk-discount--popup': isPopup }">
        <p class="license-bulk-discount__slogan">
          {{ lg.licenseBlock.getSlogan(bulkDiscount.buyedLicenseCount, bulkDiscount.bonusLicenseCount) }}
        </p>
        @if (!isPopup) {
          <div class="btv-icon-label-double theme-licenses__itemDiscountIcon"></div>
        }
      </div>
    }
  </div>
}
